/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React from 'react';
import { Card, Upload, Button, List, Image } from 'antd';
import { PlusCircleFilled, MinusCircleFilled } from '@ant-design/icons';
import cn from 'classnames';
import classes from './Style.module.scss';

export const CardUpload = (props) => {
  const {
    title,
    value,
    onChange,
    renderFileItem,
    renderTopContent = undefined,
    uploadBtnText = 'Add',
    uploadBtnIcon = <PlusCircleFilled />,
    uploadProps = {
      multiple: true,
    },
    uploadPlacement = 'top',
    shouldShowUpload,
    className,
  } = props;
  const [fileList, setFileList] = React.useState([]);

  const handleDelete = (deleteAt) => {
    const next = [...fileList];
    next.splice(deleteAt, 1);
    setFileList(next);
    if (onChange) {
      onChange(next);
    }
  };

  const handleChange = ({ fileList: fileListChanged }) => {
    const { multiple } = uploadProps;

    if (multiple) {
      setFileList(fileListChanged);
      if (onChange) {
        onChange(fileListChanged);
      }
    } else {
      let newFileList = [...fileListChanged];

      // Limit to one file
      newFileList = newFileList.slice(-1);
      setFileList(newFileList);
      if (onChange) {
        onChange(newFileList);
      }
    }
  };

  const getObjectUrl = (file) => {
    return URL.createObjectURL(file);
  };

  const showUpload = React.useMemo(() => {
    if (shouldShowUpload) {
      return shouldShowUpload(fileList);
    }
    return true;
  }, [fileList]);

  React.useEffect(() => {
    setFileList(value || []);
  }, [value]);

  return (
    <Card
      className={cn(classes.cardUpload, className)}
      title={title}
      extra={
        uploadPlacement === 'top' &&
        showUpload && (
          <Upload
            onChange={handleChange}
            fileList={fileList}
            showUploadList={false}
            beforeUpload={false}
            {...uploadProps}>
            <Button
              className={cn(classes.uploadButton, classes.placementTop)}
              icon={uploadBtnIcon}
              type="link">
              {uploadBtnText}
            </Button>
          </Upload>
        )
      }>
      {renderTopContent && renderTopContent(fileList)}
      <List
        className={classes.fileList}
        split={false}
        dataSource={fileList}
        renderItem={(record, index) => {
          if (renderFileItem) return renderFileItem(record, index);
          const fileUrl = record.url || URL.createObjectURL(record.originFileObj);
          return (
            <List.Item className={classes.item}>
              <div>
                <Button
                  onClick={() => {
                    handleDelete(index);
                    if (fileUrl.startsWith('blob:')) {
                      URL.revokeObjectURL(fileUrl);
                    }
                  }}
                  type="text"
                  danger
                  icon={<MinusCircleFilled />}
                />
                <a href={fileUrl} target="_blank" rel="noreferrer">
                  <Image preview={false} src={fileUrl} width={96} height={96} />
                </a>
              </div>
            </List.Item>
          );
        }}
      />
      {uploadPlacement === 'bottom' && showUpload && (
        <Upload
          onChange={handleChange}
          fileList={fileList}
          showUploadList={false}
          beforeUpload={false}
          {...uploadProps}>
          <Button
            className={cn(classes.uploadButton, classes.placementBottom)}
            icon={uploadBtnIcon}
            type="link">
            {uploadBtnText}
          </Button>
        </Upload>
      )}
    </Card>
  );
};
